import { AxiosError } from 'axios'
import { compose, isEmpty, isNil, not, pickBy } from 'ramda'
import useSWR, { Fetcher, Key, SWRConfiguration } from 'swr'

const pickNotNil = pickBy(compose(not, isNil))

const createCacheQueryKey = (
  query: Record<string, any>,
  cacheKey?: string
): Key =>
  cacheKey && !isEmpty(cacheKey)
    ? `${cacheKey}-${JSON.stringify(pickNotNil(query))}`
    : null

const useReportSWR = <Data = any>(
  key: string,
  query: Record<string, any>,
  fetchFn: Fetcher<Data>,
  config?: SWRConfiguration
) => useSWR<Data, AxiosError>(createCacheQueryKey(query, key), fetchFn, config)

export default useReportSWR
